import { Button } from '@beeline/design-system-react/extracted-styles';

import type { ButtonProps } from './types';

export const ButtonMessage = ({ title, ...props }: ButtonProps) => (
  <Button size='medium' {...props}>
    {title}
  </Button>
);
